import styled from '@emotion/styled'

import media from '../../../common/MediaQueries'
import { transition } from '../../../common/Mixins'
import { WithTheme } from '../../../setup/index'

const DownloadItemTextStyled = styled.div`
  padding: 0.5rem 0 1.125rem;
  border-bottom: 0.0625rem solid #707070;
  width: 100%;

  @media ${media.phone} {
    padding: 0.5rem 0 1.75rem;
  }
`

const DownloadItemIconStyled = styled.div<WithTheme>`
  ${transition}
  position: relative;
  top: 0.625rem;
  display: flex;
  margin-left: 1.125rem;
  color: ${({ theme }) => theme.colors.white};
  width: 3.1875rem;

  svg {
    width: 100%;
    height: 3.3125rem;
  }
`

const DownloadItemStyled = styled.a<WithTheme>`
  ${transition}
  display: flex;
  align-items: flex-end;
  width: 100%;

  &:hover {
    color: ${({ theme }) => theme.colors.green};

    ${DownloadItemIconStyled} {
      color: ${({ theme }) => theme.colors.green};
    }
  }
`

export { DownloadItemStyled, DownloadItemTextStyled, DownloadItemIconStyled }
